import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export default function MyAlert({
    children,
    title=null,
    ...otherProps
}) {
    return (
        <Alert {...otherProps}>
            {
                title && <AlertTitle>{title}</AlertTitle>
            }
            {children}
        </Alert>
    );
}